import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  getTaxEstimation,
  getTaxEstimationControl,
  updateTaxEstimationControl,
} from '~/services/ConnectionGoogleService';

const taxEstimationQueryKeys = {
  all: ['connection-google', 'tax-estimation'] as const,
  control: ['connection-google', 'tax-estimation', 'control'] as const,
};

export function useGetTaxEstimation(propertyId?: string, currency = 'USD') {
  return useQuery({
    queryKey: [...taxEstimationQueryKeys.all, 'overview', propertyId ?? '', currency],
    queryFn: async ({ signal }) => (await getTaxEstimation(signal, propertyId, currency)).result,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function useUpdateTaxEstimationControl() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTaxEstimationControl,
    onSuccess: ({ result }) => {
      queryClient.setQueryData(taxEstimationQueryKeys.control, result);
    },
  });
}

export function useGetTaxEstimationControl() {
  return useQuery({
    queryKey: taxEstimationQueryKeys.control,
    queryFn: async ({ signal }) => (await getTaxEstimationControl(signal)).result,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
